export default __webpack_public_path__ + "static/blockScience-f2e076c26064153bca662213d9386caa.svg";